<template>
    <BreadCrumb PageTitle="Modifier un document" />
    <EditDocument/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditDocument from "@/components/Document/EditDocument.vue";
  
    export default defineComponent({
      name: "EditDocumentPage",
      components: {
        BreadCrumb,
        EditDocument,
      },
    });
  </script>